<template>
  <span class="supported-network">
    <a-button
      v-ripple
      @click="show"
      :title="title"
      type="default"
    >
      <i
        class="mdi mdi-plus increased"
        v-if="mode === 'new'" />
      <i
        class="mdi mdi-pencil-circle-outline"
        v-if="mode !== 'new'" />
    </a-button>
    <a-drawer
      :width="700"
      :title="'supported-network-editor.lbl-supported-network' | globalize"
      placement="right"
      :visible="visible"
      :footer-style="{ textAlign: 'right' }"
      @close="onClose"
    >
      <a-form
        :form="form"
        layout="horizontal"
      >
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-network-editor.lbl-name' | globalize"
        >
          <a-input
            :placeholder="'supported-network-editor.help-name' | globalize"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: 'Please input name' }] },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-network-editor.lbl-network' | globalize"
        >
          <a-input
            :placeholder="'supported-network-editor.help-network' | globalize"
            v-decorator="[
              'network',
              { rules: [{ required: true, message: 'Please input network' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-network-editor.lbl-network-id' | globalize"
        >
          <a-input
            :placeholder="'supported-network-editor.help-network-id' | globalize"
            v-decorator="[
              'networkId',
              {
                rules: [
                  { required: true, message: 'Please input networkId' },
                  { validator: validateNumber }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-chain-id' | globalize"
        >
          <a-input
            :placeholder="'supported-network-editor.help-chain-id' | globalize"
            v-decorator="[
              'chainId',
              {
                rules: [
                  { required: true, message: 'Please input chainId' },
                  { validator: validateNumber }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-rpc' | globalize"
        >
          <a-input
            v-decorator="[
              'rpc',
              {
                rules: [
                  { required: true, message: 'Please input RPC URL' },
                  { validator: validateUrl }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-wssRpc' | globalize"
        >
          <a-input
            v-decorator="[
              'wssRpc',
              {
                rules: [
                  { required: true, message: 'Please input WSS RPC URL' },
                  { validator: validateWssUrl }
                ]
              },
            ]"
            :placeholder="'supported-network-editor.help-subgraph-url' | globalize"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-subgraph-url' | globalize"
        >
          <a-input
            v-decorator="[
              'subgraphUrl',
              {
                rules: [
                  { required: true, message: 'Please input subgraph URL' },
                  { validator: validateUrl }
                ]
              },
            ]"
            :placeholder="'supported-network-editor.help-subgraph-url' | globalize"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-explorer-url' | globalize"
        >
          <a-input
            v-decorator="[
              'explorerUrl',
              {
                rules: [
                  { required: true, message: 'Please input subgraph URL' },
                  { validator: validateUrl }
                ]
              },
            ]"
            :placeholder="'supported-network-editor.help-subgraph-url' | globalize"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-min-owner-balance' | globalize"
        >
          <a-input
            v-decorator="[
              'minOwnerBalance',
              {
                rules: [
                  { required: true, message: 'Please input minimal owner balance' },
                  { validator: validateDecimal }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-smt-distributor-address' | globalize"
        >
          <a-input
            v-decorator="[
              'smtDistributorContract',
              {
                rules: [
                  { required: true, message: 'Please input smt distributor contract address' },
                  { validator: validateAddress }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-permission-manager-address' | globalize"
        >
          <a-input
            v-decorator="[
              'permissionManagerAddress',
              {
                rules: [
                  { required: true, message: 'Please input permission manager address' },
                  { validator: validateAddress }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-bpool-proxy-address' | globalize"
        >
          <a-input
            v-decorator="[
              'bpoolProxyAddress',
              {
                rules: [
                  { required: true, message: 'Please input bpoolProxyAddress' },
                  { validator: validateAddress }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-action-manager-address' | globalize"
        >
          <a-input
            v-decorator="[
              'actionManagerAddress',
              {
                rules: [
                  { required: true, message: 'Please input action manager address' },
                  { validator: validateAddress }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-dotc-manager-address' | globalize"
        >
          <a-input
            v-decorator="[
              'offerListenerAddress',
              {
                rules: [
                  { required: true, message: 'Please input DOTC manager address' },
                  { validator: validateAddress }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-asset-token-address' | globalize"
        >
          <a-input
            v-decorator="[
              'assetTokenAddress',
              {
                rules: [
                  { required: false, validator: validateAddress }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'supported-networks.lbl-cpk-factory-address' | globalize"
        >
          <a-input
            v-decorator="[
              'cpkFactoryAddress',
              {
                rules: [
                  { required: true, message: 'Please input cpk factory address' },
                  { validator: validateAddress }
                ]
              },
            ]"
          />
        </a-form-item>

        <a-divider />

        <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
          <a-button
            style="margin-right: 8px"
            @click="onClose">Cancel</a-button>
          <a-button
            type="primary"
            :loading="loading"
            @click="onSubmit">Submit</a-button>
        </a-form-item>
      </a-form>
    </a-drawer>
  </span>
</template>

<script>
import AForm from 'ant-design-vue/lib/form'
import AInput from 'ant-design-vue/lib/input'
import AButton from 'ant-design-vue/lib/button'
import ADrawer from 'ant-design-vue/lib/drawer'
import ADivider from 'ant-design-vue/lib/divider'
import { SupportedNetworkRecord } from '@/js/records/entities/supported-network.record'

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}
const formTailLayout = {
  labelCol: { span: 16 },
  wrapperCol: { span: 16, offset: 16 },
}

export default {
  name: 'supported-network-editor',
  components: {
    ADrawer,
    AButton,
    AInput,
    ADivider,
    AForm,
    AFormItem: AForm.Item,
  },
  props: {
    onAdd: {
      type: Function,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    network: {
      type: SupportedNetworkRecord,
      default: new SupportedNetworkRecord({}),
    },
    mode: {
      type: String,
      default: 'new',
    },
    title: {
      type: String,
      default: 'Add new network',
    },
  },
  data () {
    return {
      visible: false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, {
        name: 'network',
      }),
    }
  },
  methods: {
    onSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          return this.onAdd(values, this.mode)
        }
      })
    },

    onClose () {
      this.visible = false
    },

    show () {
      Object.keys(this.network).forEach(key => {
        if (key === 'addresses') {
          this.network.addresses.forEach(n => {
            this.form.getFieldDecorator(n.key, { initialValue: n.value })
          })
        } else {
          this.form.getFieldDecorator(key, { initialValue: this.network[key] })
        }
      })

      this.visible = !this.visible
    },

    validateNumber (rule, value, callback) {
      if (value && /^\d+$/.test(value)) {
        callback()
        return
      }
      /* eslint-disable-next-line */
      callback('Should be a number')
    },

    validateAddress (rule, value, callback) {
      if (value && value.length > 0 && /^0x[a-fA-F0-9]{40}$/.test(value)) {
        callback()
        return
      }
      if (!rule.required && value.length > 0 && /^0x[a-fA-F0-9]{40}$/.test(value)) {
        callback()
        return
      }
      if (!rule.required && value.length === 0) {
        callback()
        return
      }
      if (rule.required && value && value.length === 0) {
        /* eslint-disable-next-line */
        callback('Fill the field')
        return
      }
      /* eslint-disable-next-line */
      callback('Should be a ethereum address')
    },

    validateDecimal (rule, value, callback) {
      // return (input - 0) == input && (''+input).trim().length > 0;
      /* eslint-disable-next-line */
      if (value && (value - 0) == value && ('' + value).trim().length > 0) {
        callback()
        return
      }
      /* eslint-disable-next-line */
      callback('Should be a decimal number')
    },

    validateUrl (rule, value, callback) {
      /* eslint-disable-next-line */
      if (value && /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(value)) {
        callback()
        return
      }
      /* eslint-disable-next-line */
      callback('Should be a https URL')
    },

    validateWssUrl (rule, value, callback) {
      /* eslint-disable-next-line */
      if (value && /(wss):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(value)) {
        callback()
        return
      }
      /* eslint-disable-next-line */
      callback('Should be a WSS URL')
    },
  },
}

</script>

<style lang="scss" scoped>
  @import '~@scss/variables';
  @import '~ant-design-vue/lib/button/style/index.css';
  @import '~ant-design-vue/lib/drawer/style/index.css';
  @import '~ant-design-vue/lib/input/style/index.css';
  @import '~ant-design-vue/lib/divider/style/index.css';
  @import '~ant-design-vue/lib/form/style/index.css';

  .supported-network .supported-network-input {
    width: 100%;
  }
</style>
